import client from '../../../common/client';

export const GET_COURSE = 'GET_COURSE';
export const GET_COURSES = 'GET_COURSES';
export const GET_FEATURED_COURSE = 'GET_FEATURED_COURSE';
export const GET_QUIZ = 'GET_QUIZ';
export const SUBMIT_QUIZ = 'SUBMIT_QUIZ';
export const GET_COURSE_PREVIEW = 'GET_COURSE_PREVIEW';
export const GET_LESSON_VIDEO = 'GET_LESSON_VIDEO';
export const COMPLETE_LESSON = 'COMPLETE_LESSON';
export const COMPLETE_CHAPTER = 'COMPLETE_CHAPTER';
export const ENROLL_COURSE = 'ENROLL_COURSE';
export const ENROLL_COURSE_RESET = 'ENROLL_COURSE_RESET';
export const COMPLETE_COURSE = 'COMPLETE_COURSE';

export const getCourses = () => ({
  promise: client.get('courses'),
  type: GET_COURSES,
});

export const getCourse = id => ({
  promise: client.get(`courses/${id}`),
  type: GET_COURSE,
});

export const getFeaturedCourse = () => ({
  promise: client.get('courses/featured'),
  type: GET_FEATURED_COURSE,
});

export const getQuiz = id => ({
  promise: client.get(`quizzes/${id}?decoratePassed=true`),
  type: GET_QUIZ,
});

export const submitQuiz = (id, answers) => ({
  promise: client.post(`quizzes/${id}/results`, { answers }),
  type: SUBMIT_QUIZ,
});

export const resetQuiz = () => ({
  type: `${SUBMIT_QUIZ}_RESET`,
});

export const getCoursePreview = courseId => ({
  promise: client.get(`courses/${courseId}/video`, null, {
    credentials: 'include', // Required for browser to respect Set-Cookie headers
  }),
  type: GET_COURSE_PREVIEW,
});

export const getLessonVideo = (courseId, chapterId, lessonId) => ({
  promise: client.get(`courses/${courseId}/chapters/${chapterId}/lessons/${lessonId}/video`, null, {
    credentials: 'include', // Required for browser to respect Set-Cookie headers
  }),
  type: GET_LESSON_VIDEO,
});

export const completeLesson = lessonId => ({
  promise: client.post(`progress/lessons`, { id: lessonId }),
  type: COMPLETE_LESSON,
  lessonId,
});

export const completeChapter = chapterId => ({
  promise: client.post(`progress/chapters`, { id: chapterId }),
  type: COMPLETE_CHAPTER,
  chapterId,
});

export const enrollCourse = courseId => ({
  promise: client.post(`courses/${courseId}/enroll`),
  type: ENROLL_COURSE,
  courseId,
});

export const resetCourseEnrollment = () => ({
  type: ENROLL_COURSE_RESET,
});

export const completeCourse = courseId => ({
  promise: client.post(`progress/courses`, { id: courseId }),
  type: COMPLETE_COURSE,
  courseId,
});



// WEBPACK FOOTER //
// ./src/subscription/courses/redux/actions.js